/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFunctionAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="m2 20.756.69-.746c.46-.497.809-.995 1.047-1.492s.425-1.108.563-1.831l1.932-7.7H4.254l.23-1.199 2.047-.475.322-1.56C7.36 3.251 8.778 2 11.108 2c.491 0 .92.023 1.288.068l-.299 1.583h-.759c-.75 0-1.31.188-1.679.565-.368.377-.636.957-.805 1.74l-.253 1.357h2.806l-.322 1.674H8.256l-1.932 7.88a9.487 9.487 0 0 1-.483 1.753c-.2.505-.452.972-.759 1.402-.307.43-.69.885-1.15 1.368l-.598.61zm9.165-3.64 4.383-5.195-1.945-4.608h2.186l1.23 3.432 2.704-3.432H22l-3.968 4.743 2.22 5.06h-2.185l-1.53-3.861-3.048 3.861z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgFunctionAlt as FunctionAlt };
